import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { fadeInOutHeight } from '@app/animations/fade-in-out.animation';
import { ModalProvider } from '@app/components/_shared/modal/modal.component';
import { ForgottenPasswordModel } from '@app/models/auth/forgottenPassword.model';
import { ForgottenPasswordResponse } from '@app/models/auth/forgottenPasswordResponse.model';
import { AuthService } from '@app/services/auth.service';
import { LocalisationService } from '@app/services/localisation.service';
import { ResetPasswordService } from '@app/services/reset-password.service';
import { AppConfig } from 'app/app.config';

@Component({
  selector: 'app-forgotten-login',
  templateUrl: './forgotten-login.component.html',
  styleUrls: ['./forgotten-login.component.scss'],
  animations: [fadeInOutHeight]
})
export class ForgottenLoginComponent implements OnInit {
  static route: string = 'forgotten-login';

  forgottenPasswordForm: FormGroup;
  forgottenPasswordSubmitted: boolean = false;

  locale: any = {};

  public messageCopy: string;
  public formSubmitted: boolean = false;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    public modal: ModalProvider,
    public localisation: LocalisationService,
    private resetPasswordService: ResetPasswordService,
    public router: Router
  ) {}

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent('ForgottenLoginComponent');

    this.forgottenPasswordForm = this.formBuilder.group({
      email: [null, [Validators.required, Validators.pattern(AppConfig.emailRegex)]]
    });
    if (this.resetPasswordService.getPasswordTokenError() == true) {
      this.resetPasswordService.setPasswordTokenError(false);
      this.messageCopy = this.locale.passwordTokenError;
    }
  }

  setFormSubmitted(value) {
    this.formSubmitted = value;
  }

  onClickInput() {
    this.messageCopy = null;
  }

  forgottenPassword(model: ForgottenPasswordModel) {
    this.forgottenPasswordSubmitted = true;

    var showModal = false;

    if (!this.forgottenPasswordForm.valid) {
      return;
    }
    this.setFormSubmitted(true);
    this.authService
      .forgottenPassword(model)
      .finally(() => {
        if (showModal) {
          this.modal
            .create(
              this.locale.confirmationModalTitle,
              this.locale.confirmationModalMessage,
              null,
              null,
              null,
              null,
              false
            )
            .then(ok => {
              this.navigateLogin();
            });
        }
        this.setFormSubmitted(false);
      })
      .subscribe(
        succeeded => {
          showModal = true;
        },
        (err: ForgottenPasswordResponse) => {
          showModal = true;
        }
      );
  }

  navigateLogin() {
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/account/forgotten-login/forgotten-login.component.ts